<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="标题" prop="name">
      <a-input v-model="form.data.name"/>
    </a-form-model-item>
     <a-form-model-item label="副标题" prop="subName">
      <a-input v-model="form.data.subName"/>
    </a-form-model-item>

    <a-form-model-item label="描述" >
      <a-input v-model="form.data.description"/>
    </a-form-model-item>

     <a-form-model-item label="icon">
      <div class="a-input">
        <simple-uploader v-model="form.data.icon"/>
      </div>
    </a-form-model-item>
    <a-form-model-item label="商品封面图片" prop="coverPath">
      <div class="a-input">
        <simple-uploader v-model="form.data.coverPath"/>
      </div>
    </a-form-model-item>
    <a-form-model-item label="发布时间" prop="publishTime">
        <a-date-picker
            style="width: 100%"
            v-model="form.data.publishTime"
            value-format="YYYY-MM-DDTHH:mm:ss"
            :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
            type="datetime"
            placeholder="">
        </a-date-picker>
    </a-form-model-item>

    <a-form-model-item>
      <a-space>
      <a-button type="primary" v-if="!goodsBrandId" @click="onAdd">创建</a-button>
      <a-button type="primary" v-if="goodsBrandId" @click="onUpdate">更新</a-button>
      <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _queryGoodsBrand,
  _addGoodsBrand,
  _updateGoodsBrand,
} from '@/api/goodsBrandApi';
import SimpleUploader from '@/components/SimpleUploader.vue';
import moment from 'moment';

async function getGoodsBrand() {
  const result = await _queryGoodsBrand(this.goodsBrandId);
  if (result) {
    this.form.data.name = result.name;
    this.form.data.coverPath = result.coverPath;
    this.form.data.description = result.description;
    this.form.data.subName = result.subName;
    this.form.data.icon = result.icon;
    this.form.data.publishTime = result.publishTime;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addGoodsBrand({
        name: this.form.data.name,
        coverPath: this.form.data.coverPath,
        description: this.form.data.description,
        icon: this.form.data.icon,
        publishTime: this.form.data.publishTime,
        subName: this.form.data.subName,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateGoodsBrand(this.goodsBrandId, {
        name: this.form.data.name,
        coverPath: this.form.data.coverPath,
        description: this.form.data.description,
        icon: this.form.data.icon,
        publishTime: this.form.data.publishTime,
        subName: this.form.data.subName,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'GoodsBrandEdit',
  components: { SimpleUploader },
  props: {
    goodsBrandId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    goodsBrandId() {
      if (this.goodsBrandId) {
        this.getGoodsBrand();
      }
    },
  },
  methods: {
    moment,
    onAdd,
    onUpdate,
    onCancel,
    getGoodsBrand,
  },
  data() {
    return {
      form: {
        data: {
          name: '',
          icon: '',
          coverPath: '',
          description: '',
          publishTime: `${moment().format('YYYY-MM-DD')}T00:00:00`,
          subName: '',
        },
        title: '',
        rules: {
          name: [{ required: true, trigger: 'blur' }],
          coverPath: [{ required: true, trigger: 'blur' }],
          publishTime: [{ required: true, trigger: 'blur' }],
          subName: [{ required: true, trigger: 'blur' }],
        },
      },
    };
  },
  created() {
    if (this.goodsBrandId) {
      this.getGoodsBrand();
    }
  },
};
</script>
